import React from 'react';
import './PromptVersionTabs.css';

/**
 * Component for switching between "My Version" (duplicate) and "Original" prompt views
 * @param {Object} props
 * @param {string} props.activeVersion - Current active version: 'original' or 'duplicate'
 * @param {boolean} props.hasDuplicate - Whether a duplicate exists
 * @param {Function} props.onVersionChange - Callback when version changes (version: 'original' | 'duplicate')
 */
const PromptVersionTabs = ({ activeVersion, hasDuplicate, onVersionChange }) => {
  if (!hasDuplicate) {
    return null; // Don't show tabs if no duplicate exists
  }

  return (
    <div className="prompt-version-tabs">
      <button
        className={`version-tab ${activeVersion === 'duplicate' ? 'active' : ''}`}
        onClick={() => onVersionChange('duplicate')}
        aria-label="My Version"
      >
        My Version
      </button>
      <button
        className={`version-tab ${activeVersion === 'original' ? 'active' : ''}`}
        onClick={() => onVersionChange('original')}
        aria-label="Original"
      >
        Original
      </button>
    </div>
  );
};

export default PromptVersionTabs;

